<template>
<div class="chapter">
<div class="inner_page">
<p class="h1"><b>ACKNOWLEDGMENTS AND THANKS</b></p>
<p class="s-txt">First of all, we want to thank all of the talented sewists, designers, and bloggers who make up the amazing online sewing community. Without them, neither this book nor SewCanShe (<a href="http://sewcanshe.com" target="_blank">sewcanshe.com</a>) would be possible.</p>
<p class="s-txt">Second, we really must thank S. Truett Cathy, the founder of Chick-fil-A restaurants, for providing the perfect location for our weekly mommy-blogger business meetings. The ideas for this book first took shape while we sat in a Chick-fil-A booth drinking endless diet sodas as our preschoolers romped in the play area.</p>
<p class="s-txt">Third, we owe a debt of gratitude to our agent, Linda; to the tireless editors at C&amp;T for answering our many questions and guiding us through our first book-writing experience; and to the very generous shops and manufacturers that provided the fabric and supplies needed for the projects and photographs in the book (see <span href="#/36_chapter30#link51" title="Link target outside of Sample">Where to Find It Online</span>).</p>
<p class="s-txt">Thank you all. We are honored to call you our friends!</p>
<p class="h2"><b>Caroline and Sarah</b></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_acknowledgement.vue?8c6daf4a